import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'findByName'
})
export class FindByNamePipe implements PipeTransform {

    transform(id: number, valueArray: any[], key: string = 'id'): string {
        return valueArray.find(item => item[key]?.toString() === id?.toString())?.name;
    }

}
